












































































import { mapActions, mapGetters, mapState } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { ClassifiedDiscount, PricePerUnit } from '~/models/classified/types'
import { USER_NS } from '~/store/modules/shared/user/state'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import { defineComponent, PropType } from '@nuxtjs/composition-api'
import CClassifiedFavoriteButton from '~/components/shared/configurable/classified/bucket/favorite/CClassifiedFavoriteButton.vue'
import { defineComponentTranslations } from '~/utils/i18n'
import { formatNumber } from '~/utils/number'

export default defineComponent({
  components: {
    CPrice,
    CClassifiedFavoriteButton
  },
  props: {
    pricePerUnit: {
      type: Object as PropType<PricePerUnit>,
      default: null
    },
    price: {
      type: Object,
      required: true
    },
    discount: {
      type: Object as PropType<ClassifiedDiscount>,
      default: null
    },
    externalLink: {
      type: Object,
      default: null
    },
    offersEnabled: {
      type: Boolean,
      default: false,
      required: false
    },
    financeSubtext: {
      type: Boolean,
      default: false,
      required: false
    },
    hiddenFinanceText: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      categoryIds: state => state.classified?.category_ids,
      classifiedId: state => state.classified?.id,
      currentUser: state => state.currentUser
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      isPlotClassified: 'isPlotClassified',
      isPartClassified: 'isPartClassified',
      showLoanSection: 'showLoanSection',
      showFinance: 'showFinance',
      userIsOwner: 'isOwn',
      isVehicleClassified: 'isVehicleClassified',
      isInsuranceAvailable: 'isInsuranceAvailable',
      getSpecifications: 'getSpecifications'
    }),
    ...mapGetters(USER_NS, {
      isAnon: 'isAnon',
      isDealer: 'isOfTypeDealer'
    }),
    showClassifiedNumber() {
      return Boolean(this.isPartClassified && this.classifiedId)
    },
    hasButtonBeforePrice() {
      return this.isPlotClassified || this.externalLink
    },
    priceParked() {
      return this.price.extra?.price_parked || this.price.extra?.priceParked
    },
    wholesalePrice() {
      return (
        this.price.extra?.raw_price_wholesale ||
        this.price.extra?.rawPriceWholesale
      )
    },
    prices() {
      const pricesArray = [
        {
          value: this.price?.extra?.raw_price,
          tooltipText: this.discount ? this.$t('discount_price') : null
        }
      ]
      if (this.isDealer) {
        pricesArray.push({
          value: this.wholesalePrice,
          tooltipText: this.$t('wholesale_price')
        })
      }
      if (this.priceParked) {
        pricesArray.push({
          value: this.priceParked,
          tooltipText: this.$t('parked price')
        })
      }
      return pricesArray
        .filter(p => !!p.value)
        .sort((a, b) => {
          return parseFloat(a.value) - parseFloat(b.value)
        })
    },
    priceToShow() {
      if (this.price.extra.ask_price) {
        return this.price
      }
      const lowestPrice = this.prices[0]
      return { ...lowestPrice, value: `${lowestPrice.value} €` }
    },
    lineThroughPrice() {
      if (this.price.extra.ask_price) {
        return null
      } else if (this.discount?.from_price) {
        return this.discount?.from_price
      }

      // The second value appears with line-through below the lowest value
      const secondPrice = this.prices?.[1]
      if (secondPrice) {
        return `${formatNumber(secondPrice.value)} €`
      }
    }
  },
  methods: {
    ...mapActions(CLASSIFIED_VIEW_NS, {
      scrollToFinance: 'scrollToFinance',
      scrollToInsurance: 'scrollToInsurance',
      classifiedParkedStateChanged: 'classifiedParkedStateChanged'
    })
  },
  i18n: defineComponentTranslations({
    discount_price: {
      en: 'Discount price',
      el: 'Τιμή έκπτωσης'
    }
  })
})
